import { SelectItem } from '@/models/SelectItem';

export interface BcxFormFieldTextareaOptions {
  height?: number;
  enlargedHeight?: number;
  maxLength?: number;
}

export interface BcxFromFieldTextOptions {
  maxLength?: number;
  hideCharsLeft?: boolean;
  min?: number;
  max?: number;
  showX?: boolean; // Displays an "X" button to clear the text.
}

export interface BcxFormFieldDateOptions {
  earliest?: string | Date;
  latest?: string | Date;
  secondary?: boolean;
  showArrow?: boolean; // Displays the arrows on the right side of the input field.
  arrowStep?: number; // Specifies the number of days by which the date should be increased or decreased. It can only be used in combination with showArrow.
  proposedDate?: string | Date; // If a date is specified, it will be displayed when the date picker is opened.
  showX?: boolean; // Displays an "X" button to clear the date.
}

export interface BcxFormFieldCurrencyOptions {
  symbol?: string;
  decimals?: number;
  spaceCurrencySymbol?: string; // Define the padding to the right to make room for the currency, or omit it if there is none.
}

export enum BcxFormValidation {
  EMAIL = 'email',
  ZIP = 'zip'
}

export type BcxFormCustomValidation = (value: string, data: Record<string, string>) => string | null;
export type AtBeforeInputValidation = (event: InputEvent) => void;

export interface BcxFormFieldErrorMessage {
  message: string;
  isVisible: boolean;
}

export interface BcxFormValueField {
  name: string;
  label: string;
  labelHint?: string; // small text right after the label
  showDisabledLabel?: boolean; // Displays the label grayed out even if disabled is true.
  width?: string;
  justify?: 'start' | 'end';
}

export interface BcxFormField extends BcxFormValueField {
  type: 'text' | 'textarea' | 'select' | 'checkbox' | 'date' | 'plaintext' | 'number' | 'currency';
  fieldWidth?: string;
  placeholder?: string;
  required?: boolean;
  validations?: Array<BcxFormValidation | BcxFormCustomValidation>;
  atBeforeInput?: Array<AtBeforeInputValidation>;
  disabled?: boolean;
  suffix?: string;
  options?: SelectItem[];
  textareaOptions?: BcxFormFieldTextareaOptions;
  dateOptions?: BcxFormFieldDateOptions;
  currencyOptions?: BcxFormFieldCurrencyOptions;
  translatedPlaintext?: string; // used for plaintext fields to display a translated string instead of the value
  errorMessage?: BcxFormFieldErrorMessage;
  triggerValidation?: boolean; // used in reactive field structures to trigger re-validation of field (for example, when combined with other fields)
  justify?: 'start' | 'end';
  sonderlocke?: 'primary-placeholder';
  hint?: string;
  textOptions?: BcxFromFieldTextOptions;
  isTextareaEnlarged?: boolean;
  mode?: 'select' | 'input' | 'hybrid';
}
